/**
 * @generated SignedSource<<98fa8e73f33cccf844fc94939fab2e4a>>
 * @relayHash 21ed6d73126532152c226700f74fa15b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 59a84b940089ef439c94bc268f68bb3456ce8acf0dbabbcd0e2403aeaa627bc2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraMoveVersionToEndInput = {
  id: string;
};
export type table_moveVersionToEndMutation$variables = {
  input: JiraMoveVersionToEndInput;
};
export type table_moveVersionToEndMutation$data = {
  readonly jira: {
    readonly moveJiraVersionToEnd: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type table_moveVersionToEndMutation = {
  response: table_moveVersionToEndMutation$data;
  variables: table_moveVersionToEndMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraUpdateVersionPayload",
        "kind": "LinkedField",
        "name": "moveJiraVersionToEnd",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "table_moveVersionToEndMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "table_moveVersionToEndMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "59a84b940089ef439c94bc268f68bb3456ce8acf0dbabbcd0e2403aeaa627bc2",
    "metadata": {},
    "name": "table_moveVersionToEndMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "245d2bb9c0de6e4e57289b64dc0c5201";

export default node;
